import styled from "styled-components";

const ViewPerfil = styled.div`
  width: 100%;
  position: relative;
  height: calc(100vh - 12rem);
  padding: 5rem 5rem 5rem 10rem;
  gap: 10rem;
  display: grid;
  grid-template-columns: calc(40% - 2px - 4rem) 2px calc(50% - 4rem);

  @media (max-width: 1024px) {
    padding: 5rem 5rem 18rem 5rem;
    grid-template-columns: 100%;
    gap: 0;
  }
`;

const ViewModalPermissoes = styled.div`
padding: 0 5%;
.titulo{
  text-align: left;
  font-weight: bold;
}
.texto{
  text-align: left;
  margin-bottom: 3rem;
}
`;

const ViewModalDetalhesAssinatura = styled.div`
    padding: 1rem;
    
    .loading-detalhes{
        padding-bottom: 5rem;
    }

    .info-row {
        display: flex;
        justify-content: space-between;
        padding: 0.8rem 0;
        border-bottom: 1px solid ${(props) => props.theme.colors.elements};

        &:last-child {
            border-bottom: none;
        }
    }

    .info-label {
        color: ${(props) => props.theme.colors.tertiary};
        font-size: 14px;
    }

    .info-value {
        color: ${(props) => props.theme.colors.secondary};
        font-weight: 600;
        font-size: 14px;
    }

    .section-title {
        color: ${(props) => props.theme.colors.primary};
        font-weight: bold;
        font-size: 16px;
        margin: 1.5rem 0 0.5rem 0;
    }

    .cupom-badge {
        background-color: ${(props) => props.theme.colors.primary};
        color: ${(props) => props.theme.colors.white};
        padding: 0.3rem 0.8rem;
        border-radius: 10rem;
        font-size: 12px;
        font-weight: bold;
        margin-left: 0.5rem;
    }

    .trial-info {
        background-color: ${(props) => props.theme.colors.elements};
        padding: 1rem 4rem;
        border-radius: 10rem;
        margin-bottom: 5rem;
    }

    .desconto {
        color: ${(props) => props.theme.colors.secondary};
    }

    .valor-final {
        position: relative;
        margin-top: 0.5rem;
        padding-top: 1rem;

        &::after {
            content: "";
            position: absolute;
            top: calc(-0.5rem - 1px);
            left: 0;
            right: 0;
            height: 2px;
            background-color: ${(props) => props.theme.colors.primary};
            border-radius: 9999px;
        }

        .info-label, .info-value {
            font-weight: bold;
            font-size: 16px;
        }

        .info-value {
            color: ${(props) => props.theme.colors.secondary};
        }
    }
`;

const Middle = styled.div`
  width: 100%;
  height: 80%;
  background-color: ${(props) => props.theme.colors.elements};
  align-self: center;
`;

const LeftRight = styled.div`
    gap: 2rem;
    position: relative;
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    
    @media(min-width: 992px){
        padding-bottom: 100px;
    }

    .edicao-usuario {
        > .titulo {
            text-align: left;
            color: ${(props) => props.theme.colors.secondary};
            font-weight: bold;
        }

        .detalhes {
            text-align: left;
            margin-bottom: 5rem;
        }

        .titulo_input {
            text-align: left;
            margin: 2rem 0 2rem 0;
            color: ${(props) => props.theme.colors.tertiary};
        }

        .campos {
            .erro {
                text-align: left;
                color: ${(props) => props.theme.colors.brandDanger};
            }

            .alterar {
                display: grid;
                grid-template-columns: 85% 10%;
                align-items: center;
                justify-content: space-between;

                &.novo {
                    grid-template-columns: 100%;
                }

                .botao_alterar {
                    display: flex;
                    justify-content: flex-end;
                    text-align: right;
                    color: ${(props) => props.theme.colors.primary};
                    cursor: pointer;
                }


                @media (max-width: 385px) {
                    grid-template-columns: 80% 20%;
                }
            }

            .alterar_sem_botao {
                display: grid;
                grid-template-columns: 100%;
                align-items: center;
            }

            .select {
                margin-top: 1rem;
            }
        }

        .campos > * {
            margin-top: 20px;
        }

        .botoes_ {
            display: flex;
            margin-top: 8rem;
            justify-content: space-between;
            align-items: center;

            .novo_usuario {
                color: ${(props) => props.theme.colors.primary};
                cursor: pointer;
                display: flex;
                gap: 1rem;

                &.bloqueado {
                    color: ${(props) => props.theme.colors.disable} !important;
                }
            }
        }

        .linha_abaixo {
            margin-top: 10rem;
            width: 100%;
            height: 2px;
            background-color: ${(props) => props.theme.colors.elements};
        }

        .titulo_assinatura {
            margin-top: 10rem;
            text-align: left;
            color: ${(props) => props.theme.colors.secondary};
            font-weight: bold;
        }

        .alterar {
            display: grid;
            grid-template-columns: 85% 15%;
            align-items: center;
            justify-content: space-between;

            .botao_alterar {
                text-align: right;
                color: ${(props) => props.theme.colors.primary};
                cursor: pointer;
                margin-top: 20px;
            }


            .botao_excluir {
                text-align: right;
                color: ${(props) => props.theme.colors.primary};
                cursor: pointer;
                margin-top: 29px;
            }
        }
    }

    .linha {
        display: flex;
        justify-content: center;

        div {
            width: 2px;
            height: 100%;
            border-radius: 10px;
            background-color: ${(props) => props.theme.colors.elements};
            box-shadow: 0 0 10px ${(props) => props.theme.colors.elements};
        }
    }
`;

export { ViewPerfil, Middle, LeftRight, ViewModalPermissoes, ViewModalDetalhesAssinatura };
